export default "__VITE_ASSET__CmpqnQNM__"